import { ROSTER } from '../game/roster.js';

// Increment when model/material/portrait lighting changes. Bounded to one art version.
export const PORTRAIT_CACHE_KEY = 'holiduel-portraits';
export const PORTRAIT_ART_VERSION = 'blue-ice-toon-2';
const MAX_BYTES = 512000;
const valid = portraits => portraits && typeof portraits === 'object' &&
  ROSTER.every(({id}) => typeof portraits[id] === 'string' && portraits[id].length < 40000 &&
    /^data:image\/webp;base64,[A-Za-z0-9+/=]+$/.test(portraits[id]));

/** Optional convenience cache; denied/quota-limited storage never blocks boot. */
export function readPortraitCache(storage) {
  try {
    const raw = (storage ?? globalThis.localStorage).getItem(PORTRAIT_CACHE_KEY);
    if (!raw || raw.length > MAX_BYTES) return null;
    const data = JSON.parse(raw);
    if (data.version !== PORTRAIT_ART_VERSION || !valid(data.portraits)) return null;
    return Object.fromEntries(ROSTER.map(({id}) => [id, data.portraits[id]]));
  } catch { return null; }
}
export function writePortraitCache(portraits, storage) {
  try {
    if (!valid(portraits)) return false;
    const raw = JSON.stringify({version:PORTRAIT_ART_VERSION, portraits:Object.fromEntries(ROSTER.map(({id}) => [id, portraits[id]]))});
    if (raw.length > MAX_BYTES) return false;
    (storage ?? globalThis.localStorage).setItem(PORTRAIT_CACHE_KEY, raw);
    return true;
  } catch { return false; }
}
